import { useState, useEffect } from 'react';
import axios from 'axios';

const BASE = process.env.REACT_APP_BACKEND_URL || '';

export function useIndustryDetail(slug) {
  const [data, setData]         = useState(null);
  const [loading, setLoading]   = useState(true);

  useEffect(() => {
    if (!slug) return;
    let cancelled = false;
    setLoading(true);
    setData(null);

    axios
      .get(`${BASE}/api/v1/industries/${slug}`)
      .then((res) => {
        if (cancelled) return;
        const item = res.data?.data ?? res.data;
        if (item && item.slug) setData(item);
      })
      .catch(() => {})
      .finally(() => { if (!cancelled) setLoading(false); });

    return () => { cancelled = true; };
  }, [slug]);

  return { data, loading };
}
